// I really don't know where to put this function
import { HttpParams } from '@angular/common/http';

export function getExtraParams(extraQS: any): HttpParams {
  let urlQS = new HttpParams();

  if(extraQS !== null) {
    for (let key in extraQS) {
      if (extraQS.hasOwnProperty(key) && extraQS[key] !== null)
        urlQS = urlQS.set(key, extraQS[key]);
    }
  }

  return urlQS;
}

export function getParams(limit: number = 0, offset: number = 0, keyword: string = '', ordering: string = '', extra: any = null) {
  let params: HttpParams = getExtraParams(extra);

  if (limit > 0) {
    params = params.set('limit', limit.toString()).set('offset', offset.toString());
  }

  if (ordering && ordering !== '') {
    params.set('ordering', ordering.toString());
  }

  if (keyword && keyword !== '') {
    params = params.set('search', keyword);
  }

  return params;
}
